<!-- 擲筊 -->
<template>
    <div class="sign-mask"
    :class="{'show': show }"
    v-show="isDisplay">
        <div class="sign-container" :class="{
            'sign-bg1':targetIdx===0,
            'sign-bg2':targetIdx===1,
            'sign-bg3':targetIdx===2}">
            <a href="" class="close-btn" @click.prevent="$parent.popup()"
            v-show="isShowSign">
                <img src="@/assets/images/popup/btn_popup_close@2x.png" alt="">
            </a>
            <!--筊-->
            <div class="throw-wrapper">
                <template v-if="targetIdx===1">
                    <img src="@/assets/images/sign/img_throw_1@2x_v2.png" alt=""
                    v-show="currentIdx === 1 && !isPc">
                    <img src="@/assets/images/sign/img_throw_1@3x_v2.png" alt=""
                    v-show="currentIdx === 1 && isPc">

                    <img src="@/assets/images/sign/img_throw_2@2x_v2.png" alt=""
                    v-show="currentIdx === 2 && !isPc">
                    <img src="@/assets/images/sign/img_throw_2@3x_v2.png" alt=""
                    v-show="currentIdx === 2 && isPc">

                    <img src="@/assets/images/sign/img_throw_3@2x_v2.png" alt=""
                    v-show="currentIdx === 3 && !isPc">
                    <img src="@/assets/images/sign/img_throw_3@3x_v2.png" alt=""
                    v-show="currentIdx === 3 && isPc">

                    <img src="@/assets/images/sign/img_throw_4@2x_v2.png" alt=""
                    v-show="currentIdx === 4 && !isPc">
                    <img src="@/assets/images/sign/img_throw_4@3x_v2.png" alt=""
                    v-show="currentIdx === 4 && isPc">

                    <img src="@/assets/images/sign/img_throw_5@2x_v2.png" alt=""
                    v-show="currentIdx === 5 && !isPc">
                    <img src="@/assets/images/sign/img_throw_5@3x_v2.png" alt=""
                    v-show="currentIdx === 5 && isPc">

                    <img src="@/assets/images/sign/img_throw_6@2x_v2.png" alt=""
                    v-show="currentIdx === 6 && !isPc">
                    <img src="@/assets/images/sign/img_throw_6@3x_v2.png" alt=""
                    v-show="currentIdx === 6 && isPc">
                </template>
                <template v-if="targetIdx===2">
                    <img src="@/assets/images/sign/img_throw_1@2x_v3.png" alt=""
                    v-show="currentIdx === 1 && !isPc">
                    <img src="@/assets/images/sign/img_throw_1@3x_v3.png" alt=""
                    v-show="currentIdx === 1 && isPc">

                    <img src="@/assets/images/sign/img_throw_2@2x_v3.png" alt=""
                    v-show="currentIdx === 2 && !isPc">
                    <img src="@/assets/images/sign/img_throw_2@3x_v3.png" alt=""
                    v-show="currentIdx === 2 && isPc">

                    <img src="@/assets/images/sign/img_throw_3@2x_v3.png" alt=""
                    v-show="currentIdx === 3 && !isPc">
                    <img src="@/assets/images/sign/img_throw_3@3x_v3.png" alt=""
                    v-show="currentIdx === 3 && isPc">

                    <img src="@/assets/images/sign/img_throw_4@2x_v3.png" alt=""
                    v-show="currentIdx === 4 && !isPc">
                    <img src="@/assets/images/sign/img_throw_4@3x_v3.png" alt=""
                    v-show="currentIdx === 4 && isPc">

                    <img src="@/assets/images/sign/img_throw_5@2x_v3.png" alt=""
                    v-show="currentIdx === 5 && !isPc">
                    <img src="@/assets/images/sign/img_throw_5@3x_v3.png" alt=""
                    v-show="currentIdx === 5 && isPc">

                    <img src="@/assets/images/sign/img_throw_6@2x_v3.png" alt=""
                    v-show="currentIdx === 6 && !isPc">
                    <img src="@/assets/images/sign/img_throw_6@3x_v3.png" alt=""
                    v-show="currentIdx === 6 && isPc">
                </template>
                <template v-else>
                    <img src="@/assets/images/sign/img_throw_1@2x.png" alt=""
                    v-show="currentIdx === 1 && !isPc">
                    <img src="@/assets/images/sign/img_throw_1@3x.png" alt=""
                    v-show="currentIdx === 1 && isPc">

                    <img src="@/assets/images/sign/img_throw_2@2x.png" alt=""
                    v-show="currentIdx === 2 && !isPc">
                    <img src="@/assets/images/sign/img_throw_2@3x.png" alt=""
                    v-show="currentIdx === 2 && isPc">

                    <img src="@/assets/images/sign/img_throw_3@2x.png" alt=""
                    v-show="currentIdx === 3 && !isPc">
                    <img src="@/assets/images/sign/img_throw_3@3x.png" alt=""
                    v-show="currentIdx === 3 && isPc">

                    <img src="@/assets/images/sign/img_throw_4@2x.png" alt=""
                    v-show="currentIdx === 4 && !isPc">
                    <img src="@/assets/images/sign/img_throw_4@3x.png" alt=""
                    v-show="currentIdx === 4 && isPc">

                    <img src="@/assets/images/sign/img_throw_5@2x.png" alt=""
                    v-show="currentIdx === 5 && !isPc">
                    <img src="@/assets/images/sign/img_throw_5@3x.png" alt=""
                    v-show="currentIdx === 5 && isPc">

                    <img src="@/assets/images/sign/img_throw_6@2x.png" alt=""
                    v-show="currentIdx === 6 && !isPc">
                    <img src="@/assets/images/sign/img_throw_6@3x.png" alt=""
                    v-show="currentIdx === 6 && isPc">
                </template>
            </div>
            <!--籤詩-->
            <div class="sign" :class="{'active': isShowSign}"
            v-show="currentPoem && currentPoem.image_path">
                <img :src="currentPoem.image_path" alt="">
            </div>
            <!--按鈕-->
            <div class="btn-wrapper" v-show="isShowSign">
                <a href="" class="sign-btn play"
                @click.prevent="onPlay();gaEvent('game_bt', 'game_replay');">
                    再玩一次
                </a>
                <a href="" class="sign-btn share"
                @click.prevent="$parent.onShare('fb', currentPoem.share_link);
                gaEvent('share_fb', 'game_share');" v-if="currentPoem">
                    立即分享
                </a>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import mixinMethod from '@/js/mixin/mixinMethod';

export default {
    props: {
        show: {
            type: Boolean,
            default: false,
            required: true,
        },
        poems: {
            type: Array,
            default() {
                return [
                    {
                        image_path: '',
                        share_link: '',
                    },
                ];
            },
        },
        isPc: {
            type: Boolean,
        },
        targetPoemId: {
            type: Number,
        },
        targetIdx: {
            type: Number,
        },
    },
    data() {
        return {
            isDisplay: false,
            currentIdx: 0,
            isShowSign: false,
            currentPoem: {
                image_path: '',
                share_link: '',
            },
            isIgnore: false,
        };
    },
    mounted() {
        if (this.targetPoemId) {
            this.$parent.popup();
        }
    },
    methods: {
        onClear() {
            this.currentIdx = 0;
            this.isShowSign = false;
            this.currentPoem = {
                image_path: '',
                share_link: '',
            };
        },
        onPlay() {
            this.onClear();
            window.setTimeout(() => {
                window.sign = window.setInterval(() => {
                    if (this.currentIdx !== 6) {
                        this.currentIdx += 1;
                    } else {
                        window.clearInterval(window.sign);
                        this.$parent.triggerSignMusic();
                        this.getSign();
                    }
                }, 100);
            }, 1000);
        },
        getSign() {
            const n = this.poems.length;
            let idx = 0;
            let arr = [];
            if (this.targetPoemId && !this.isIgnore) {
                arr = this.poems.filter(item => item.poem_id === this.targetPoemId);
                this.isIgnore = true;
            } else {
                const tempNum = Math.round(n * window.Math.random());
                idx = tempNum ? tempNum - 1 : tempNum;
            }
            this.currentPoem = arr.length ? arr[0] : this.poems[idx];
            window.setTimeout(() => {
                this.isShowSign = true;
            }, 1500);
        },
    },
    watch: {
        show(val) {
            this.onClear();
            if (!val) {
                window.setTimeout(() => {
                    this.isDisplay = val;
                }, 800);
            } else {
                this.isDisplay = val;
                this.onPlay();
            }
        },
    },
    mixins: [mixinMethod],
};
</script>

<style lang="sass" scoped>

.sign-mask
    background-color: rgba(#000, .8)
    width: 100vw
    height: 100vh
    top: 0
    left: 0
    position: fixed
    opacity: 0
    transition: .8s ease-in-out
    z-index: 10
    &:after
        background-image: radial-gradient(rgba(#000, .4) 25%, #000)
        content: ''
        display: block
        height: 100vh
    &.show
        opacity: 1

.sign-container
    $s: 90vw
    background-image: url('../assets/images/sign/img_gossip.png')
    background-repeat: no-repeat
    background-position: 50% 100%
    background-size: contain
    position: absolute
    text-align: center
    top: 10vh
    left: calc(50% - 45vw)
    width: $s
    height: 60vh
    &.sign-bg1
        background-image: url('../assets/images/sign/img_gossip.png')
    &.sign-bg2
        background-image: url('../assets/images/sign/img_gossip_v2.png')
    &.sign-bg3
        background-image: url('../assets/images/sign/img_gossip.png')

.close-btn
    position: absolute
    right: 20vw
    top: -2em
    z-index: 2

.throw-wrapper
    $s: 80vw
    width: $s
    height: 73vw
    position: absolute
    margin: 0 auto
    bottom: 0
    left: calc(50% - 40vw)
    img
        width: 100%
        position: absolute
        left: 0
        top: 0

.sign
    width: 28vh
    left: calc(50% - 14vh)
    top: 0
    position: absolute
    opacity: 0
    transition: 1s ease-out
    &.active
        opacity: 1
    img
        width: 100%

.btn-wrapper
    text-align: center
    width: 100%
    position: absolute
    bottom: -12vh

.sign-btn
    background: url('../assets/images/popup/btn_popup_common@2x.png') no-repeat 50% / contain
    color: #f2e6af
    display: inline-block
    font-size: .8em
    padding: 1.5em 2em
    vertical-align: middle
    &:hover
        text-decoration: none
    &.play
        margin-right: .4em
    &.share
        margin-left: .4em

@media (min-width: 576px)
    .sign-container
        background-image: url('../assets/images/sign/img_gossip@2x.png')
        $s: 70vw
        left: calc(50% - 35vw)
        width: $s
        height: 61vh
        &.sign-bg1
            background-image: url('../assets/images/sign/img_gossip@2x.png')
        &.sign-bg2
            background-image: url('../assets/images/sign/img_gossip_v2.png')
        &.sign-bg3
            background-image: url('../assets/images/sign/img_gossip@2x.png')

    .close-btn
        right: 16vh

    .throw-wrapper
        $s: 58vw
        width: $s
        height: 54vw
        left: calc(50% - 29vw)

    .sign
        width: 34vw
        left: calc(50% - 17vw)

@media (min-width: 768px)
    .sign-container
        background-image: url('../assets/images/sign/img_gossip@3x.png')
        $s: 32em
        left: calc(50% - 16em)
        width: $s
        height: 64vh
        &.sign-bg1
            background-image: url('../assets/images/sign/img_gossip@3x.png')
        &.sign-bg2
            background-image: url('../assets/images/sign/img_gossip_v2.png')
        &.sign-bg3
            background-image: url('../assets/images/sign/img_gossip@3x.png')

    .close-btn
        right: 14vh

    .throw-wrapper
        $s: 26em
        width: $s
        height: 24.5em
        left: calc(50% - 13em)

    .sign
        width: 30vh
        left: calc(50% - 15vh)
</style>
